const API_BASE_URL = 'https://inza-backend.sajholding.org/api/v1';

class ProductService {
  async getProducts(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString 
        ? `${API_BASE_URL}/products/?${queryString}` 
        : `${API_BASE_URL}/products/`;
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }

  async getProductById(identifier) {
    try {
      console.log('Recherche du produit avec identifier:', identifier);
      
      // D'abord essayer le backend
      try {
        // Si c'est un nombre, chercher par ID dans la liste
        if (!isNaN(identifier)) {
          console.log('Identifier est numérique, recherche par ID...');
          const allProductsResponse = await fetch(`${API_BASE_URL}/products/`);
          if (allProductsResponse.ok) {
            const products = await allProductsResponse.json();
            const product = products.find(p => p.id == identifier);
            if (product) {
              console.log('Produit trouvé par ID:', product);
              return product;
            }
          }
        } else {
          // Sinon, essayer avec le slug
          console.log('Tentative de recherche par slug:', identifier);
          const response = await fetch(`${API_BASE_URL}/products/${identifier}/`);
          
          if (response.ok) {
            const product = await response.json();
            console.log('Produit trouvé par slug:', product);
            return product;
          } else {
            // Si le slug ne fonctionne pas, essayer par nom
            const allProductsResponse = await fetch(`${API_BASE_URL}/products/`);
            if (allProductsResponse.ok) {
              const products = await allProductsResponse.json();
              const product = products.find(p => 
                p.name.toLowerCase().includes(identifier.toLowerCase()) ||
                identifier.toLowerCase().includes(p.name.toLowerCase())
              );
              if (product) {
                console.log('Produit trouvé par nom:', product);
                return product;
              }
            }
          }
        }
      } catch (backendError) {
        console.log('Backend non disponible, utilisation des données de test');
      }
      
      // Si le backend ne répond pas, utiliser des données de test
      console.log('Utilisation des données de test pour le produit:', identifier);
      const mockProducts = [
        {
          id: 1,
          name: 'iPhone 15 Pro Max',
          slug: 'iphone-15-pro-max',
          description: 'Le plus puissant des iPhone avec chip A17 Pro',
          price: 918000,
          original_price: 1050000,
          image_url: '/api/placeholder/300/300',
          product_images: [],
          category: 'smartphones',
          brand: 'Apple',
          stock: 10,
          features: ['Titanium', 'A17 Pro', 'Camera 48MP'],
          specifications: {
            screen: '6.7"',
            storage: '256GB',
            camera: '48MP',
            battery: '4423mAh'
          }
        },
        {
          id: 2,
          name: 'iPhone 15 Pro',
          slug: 'iphone-15-pro',
          description: 'Puissance et élégance au quotidien',
          price: 780000,
          original_price: 890000,
          image_url: '/api/placeholder/300/300',
          product_images: [],
          category: 'smartphones',
          brand: 'Apple',
          stock: 15,
          features: ['Titanium', 'A17 Pro', 'Camera 48MP'],
          specifications: {
            screen: '6.1"',
            storage: '128GB',
            camera: '48MP',
            battery: '3274mAh'
          }
        }
      ];
      
      const product = mockProducts.find(p => 
        p.id == identifier || 
        p.slug === identifier ||
        p.name.toLowerCase().includes(identifier.toLowerCase())
      );
      
      if (product) {
        console.log('Produit de test trouvé:', product);
        return product;
      }
      
      throw new Error('Product not found');
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  }

  async getPopularProducts() {
    return this.getProducts({ popular: 'true' });
  }

  async getProductsByCategory(category) {
    return this.getProducts({ category });
  }

  async searchProducts(query) {
    return this.getProducts({ q: query });
  }

  async getProductsByPriceRange(minPrice, maxPrice) {
    const params = {};
    if (minPrice) params.min_price = minPrice;
    if (maxPrice) params.max_price = maxPrice;
    return this.getProducts(params);
  }
}

const productService = new ProductService();
export default productService;